export function TRANSLATE(str: string) {
    return str;
}

export class Translatable {

    /** TODO améliorer ça en dynamique ?!
     * Pour récupération des traductions extracteur
     */
    index() {
        // Liste des actions

        // Liste des êvenements

        // Historique
        TRANSLATE('Création');
        TRANSLATE('Modification');
        TRANSLATE('Ajout d\'une photo');
        TRANSLATE('Suppression d\'une photo');

        // Descriptions
        TRANSLATE('Publication');
        TRANSLATE('Publicité');
        TRANSLATE('Remarques');

        // Langues
        TRANSLATE('Français');
        TRANSLATE('Anglais');
        TRANSLATE('Néerlandais');
        TRANSLATE('Texte');
    }

}
